(() => {
  if (window.TruelementsInfiniteScroll) return;
  window.TruelementsInfiniteScroll = true;

  const SELECTOR = '#product-grid[data-infinite-scroll]';
  const loadingText = '商品を読み込んでいます…';
  const completeText = 'すべての商品を表示しました';

  function initialize(scope = document) {
    const grids = scope.querySelectorAll ? scope.querySelectorAll(SELECTOR) : [];
    grids.forEach((grid) => {
      if (grid.dataset.infiniteReady === 'true') return;
      grid.dataset.infiniteReady = 'true';

      const collection = grid.closest('.collection');
      const pagination = collection?.querySelector('[data-infinite-pagination]');
      const sentinel = collection?.querySelector('[data-infinite-sentinel]');
      const status = collection?.querySelector('[data-infinite-status]');
      if (!sentinel || !pagination) return;

      pagination.hidden = true;
      let loading = false;
      let observer = null;
      let removeScrollFallback = () => {};

      const showFallback = () => {
        pagination.hidden = false;
        if (status) status.textContent = '';
      };

      const finish = () => {
        observer?.disconnect();
        removeScrollFallback();
        sentinel.hidden = true;
        if (status) status.textContent = completeText;
      };

      const loadNextPage = async () => {
        const nextUrl = grid.dataset.nextUrl;
        if (!nextUrl || loading) {
          if (!nextUrl) finish();
          return;
        }

        loading = true;
        sentinel.classList.add('is-loading');
        if (status) status.textContent = loadingText;

        try {
          const response = await fetch(nextUrl, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) throw new Error('Request failed');

          const html = await response.text();
          const page = new DOMParser().parseFromString(html, 'text/html');
          const nextGrid = page.querySelector(SELECTOR);
          if (!nextGrid) throw new Error('Product grid missing');

          const fragment = document.createDocumentFragment();
          Array.from(nextGrid.children).forEach((card) => {
            card.classList.remove('scroll-trigger', 'animate--slide-in');
            card.removeAttribute('data-cascade');
            card.style.removeProperty('--animation-order');
            fragment.appendChild(card);
          });
          grid.appendChild(fragment);
          grid.dataset.nextUrl = nextGrid.dataset.nextUrl || '';

          document.dispatchEvent(new CustomEvent('truelements:products-loaded', {
            detail: { grid, nextUrl: grid.dataset.nextUrl }
          }));

          if (!grid.dataset.nextUrl) finish();
          else if (status) status.textContent = '';
        } catch (error) {
          observer?.disconnect();
          removeScrollFallback();
          showFallback();
        } finally {
          loading = false;
          sentinel.classList.remove('is-loading');
        }
      };

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) loadNextPage();
        }, { rootMargin: '2600px 0px' });

        if (grid.dataset.nextUrl) observer.observe(sentinel);
        else finish();
      } else {
        let scheduled = false;
        const checkPosition = () => {
          scheduled = false;
          const rect = sentinel.getBoundingClientRect();
          if (rect.top <= window.innerHeight + 2600 && rect.bottom >= -1000) loadNextPage();
        };
        const scheduleCheck = () => {
          if (scheduled) return;
          scheduled = true;
          window.requestAnimationFrame(checkPosition);
        };
        window.addEventListener('scroll', scheduleCheck, { passive: true });
        window.addEventListener('resize', scheduleCheck, { passive: true });
        removeScrollFallback = () => {
          window.removeEventListener('scroll', scheduleCheck);
          window.removeEventListener('resize', scheduleCheck);
        };
        if (grid.dataset.nextUrl) scheduleCheck();
        else finish();
      }
    });
  }

  const reinitialize = () => window.requestAnimationFrame(() => initialize(document));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reinitialize, { once: true });
  } else {
    reinitialize();
  }

  new MutationObserver(reinitialize).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.addEventListener('pageshow', reinitialize);
})();